import React from 'react';
import { useParams } from 'react-router-dom';
import { useItem, useMovements, useStock } from '../hooks/useInventory';
import { DataTable } from '../components/DataTable';

const ItemDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>(); const { data: item } = useItem(id); const { data: moves } = useMovements({ itemId: id }); const { data: stock } = useStock({ itemId: id });
  if (!id) return null;
  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-semibold">Detalle de ítem</h1>
      {item && (<div className="border rounded-md p-4 bg-white text-sm space-y-1"><div><strong>SKU:</strong> {item.sku}</div><div><strong>Nombre:</strong> {item.name}</div><div><strong>Categoría:</strong> {item.category}</div><div><strong>Unidad:</strong> {item.unit}</div></div>)}
      <DataTable title="Stock" data={stock ?? []} columns={[{ key: 'location', label: 'Ubicación' }, { key: 'onHand', label: 'On-hand' }]} />
      <DataTable title="Movimientos" data={moves?.data ?? []} columns={[{ key: 'type', label: 'Tipo' }, { key: 'qty', label: 'Cantidad' }, { key: 'createdAt', label: 'Fecha' }]} />
    </div>
  );
};

export default ItemDetail;
